import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    coOpActionCreators,
    CoOpActionKeys,
    ICoOpRequestStatus,
    UpdateCoOpStatus
    } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* updateCoOpStatusSaga(action: UpdateCoOpStatus) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IEntityWithMessages<ICoOpRequestStatus> = yield call(api.updateCoOpStatus, action.payload);

  if (response.value) {
    yield put(coOpActionCreators.setActiveStatus(response.value));
  }

  yield processMessages(response);
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateCoOpStatus() {
  yield takeEvery(CoOpActionKeys.UPDATE_COOP_STATUS, updateCoOpStatusSaga);
}
